import { render, staticRenderFns } from "./TableMarkStatus.vue?vue&type=template&id=1d00ecfe&scoped=true&"
import script from "./TableMarkStatus.vue?vue&type=script&lang=js&"
export * from "./TableMarkStatus.vue?vue&type=script&lang=js&"
import style0 from "./TableMarkStatus.vue?vue&type=style&index=0&id=1d00ecfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d00ecfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
